import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Container = styled.div<{hide?:boolean}>`
    display:${props => props.hide?"none":"inherit"};
    position: relative;
    cursor: pointer;

    .react-datepicker-popper {
        z-index: 9999 !important;
    }
    
    .react-datepicker__day--selected{
        outline:none;
    }

    .react-datepicker__day--selected:hover{
        background-color: #277982 !important;
        color: #ffffff;
        border-radius: 50%;
    }
`;